var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import React, { useState, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography, Grid, Stack, Button, Select, MenuItem, Menu, FormControl, Radio, Divider, Dialog, DialogTitle, DialogContent, IconButton, CircularProgress, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import AssessmentIcon from "@mui/icons-material/Assessment";
import * as XLSX from "xlsx";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CommonHeader from "../../components/UtilityComponents/commonHeader";
import { PaymentManagementIcon, TotalTranscationIcon, TotalAmountIcon, } from "../../components/icons";
import ModuleTable from "../../components/UtilityComponents/moduleTable";
import { CustomerPortalPaymentManagementCols } from "../../config/TableColumns";
import { colors, baseColors } from "../../Themes/colors";
import MUIDatePicker from "../../components/FormComponents/DatePicker";
import SearchField from "../../components/FormComponents/SearchField";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { utility } from "../../utils";
import constants from "../../config/constants";
import moment from "moment";
import "moment-timezone";
import { formatCurrency, validateDate, } from "../../utils/commonUtilities";
import useFillViewportHeight from "../../hooks/useFillViewportHeight";
import CommonTablePagination from "../../components/UtilityComponents/commonTablePagination";
var PaymentPlatformTypes = {
    Aspire: 1,
    Stripe: 2,
};
var PaymentStatusTypes = {
    Pending: 0,
    Processed: 1,
    Cancelled: 2,
    Failed: 3,
    Disputed: 4,
};
var StripeStatusLabels = (_a = {},
    _a[PaymentStatusTypes.Pending] = "pending",
    _a[PaymentStatusTypes.Processed] = "succeeded",
    _a[PaymentStatusTypes.Cancelled] = "cancelled",
    _a[PaymentStatusTypes.Failed] = "failed",
    _a[PaymentStatusTypes.Disputed] = "disputed",
    _a);
var getPaymentPortalDisplayName = function (portalName) {
    if (!portalName || typeof portalName !== "string")
        return "";
    var normalized = portalName.trim().toLowerCase();
    if (!normalized)
        return "";
    if (normalized.includes("auxcap"))
        return "AuxCap";
    if (normalized.includes("auxilior"))
        return "Auxilior";
    if (normalized.includes("avant"))
        return "Avant";
    return portalName;
};
var CustomerPortalPaymentManagement = function () {
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var _b = useState([]), payments = _b[0], setPayments = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(1), currentPage = _d[0], setCurrentPage = _d[1];
    var _e = useState(50), recordsPerPage = _e[0], setRecordsPerPage = _e[1];
    var _f = useFillViewportHeight(), tableFillRef = _f.ref, tableFillMaxHeight = _f.maxHeight;
    var _g = useState(0), totalCount = _g[0], setTotalCount = _g[1];
    var _h = useState(0), pendingAmount = _h[0], setPendingAmount = _h[1];
    var _j = useState(0), processedAmount = _j[0], setProcessedAmount = _j[1];
    var _k = useState(0), cancelledAmount = _k[0], setCancelledAmount = _k[1];
    var todayDate = moment().format("YYYY-MM-DD");
    var weeklyFromDate = moment().subtract(6, "days").format("YYYY-MM-DD");
    var _l = useState(weeklyFromDate), fromDate = _l[0], setFromDate = _l[1];
    var _m = useState(todayDate), toDate = _m[0], setToDate = _m[1];
    var _o = useState("weekly"), period = _o[0], setPeriod = _o[1];
    var _p = useState("dropdown"), filterType = _p[0], setFilterType = _p[1];
    var _q = useState(""), searchText = _q[0], setSearchText = _q[1];
    var _r = useState(null), selectedStatusFilter = _r[0], setSelectedStatusFilter = _r[1];
    var _s = useState(null), exportAnchorEl = _s[0], setExportAnchorEl = _s[1];
    var _t = useState(null), selectedPlatformFilter = _t[0], setSelectedPlatformFilter = _t[1];
    var _u = useState(null), selectedPortalFilter = _u[0], setSelectedPortalFilter = _u[1];
    var _v = useState([]), availablePortals = _v[0], setAvailablePortals = _v[1];
    var _w = useState(false), showReports = _w[0], setShowReports = _w[1];
    var _x = useState(1), reportsPage = _x[0], setReportsPage = _x[1];
    var _y = useState(moment().year()), selectedReportsYear = _y[0], setSelectedReportsYear = _y[1];
    var _z = useState(moment().month() + 1), selectedReportsMonth = _z[0], setSelectedReportsMonth = _z[1];
    var _0 = useState([]), schedulerReports = _0[0], setSchedulerReports = _0[1];
    var _1 = useState(false), isReportsLoading = _1[0], setIsReportsLoading = _1[1];
    var MONTHS_PER_PAGE = 3;
    var contractStartDate = useState("")[0];
    var MAX_FUTURE_DAYS = 90;
    var maxAllowedDate = moment()
        .add(MAX_FUTURE_DAYS, "days")
        .format("YYYY-MM-DD");
    useEffect(function () {
        var openReports = searchParams.get("openReports");
        if (openReports === "true") {
            setShowReports(true);
            setSearchParams({}, { replace: true });
        }
    }, [searchParams, setSearchParams]);
    var exportColumns = [
        { id: "ContractId", label: "Contract ID" },
        { id: "Customer", label: "Customer Name" },
        { id: "portalName", label: "Portal Name" },
        { id: "PaymentAmount", label: "Amount" },
        { id: "Date", label: "Payment Scheduled Date" },
        { id: "Source", label: "Payment Mode" },
        { id: "PaymentStatus", label: "Aspire Status" },
        { id: "StripeTransactionId", label: "Transaction ID" },
        { id: "StripeStatus", label: "Stripe Status" },
        { id: "Comments", label: "Comments" },
    ];
    var getDateRangeLabel = function () {
        if (fromDate && toDate) {
            return "".concat(moment(fromDate).format("MM-DD-YYYY"), "_to_").concat(moment(toDate).format("MM-DD-YYYY"));
        }
        return moment().format("MM-DD-YYYY");
    };
    var parsePaymentFilterDate = function (date) {
        if (moment.isMoment(date)) {
            return date.clone();
        }
        if (typeof date === "string") {
            var trimmedDate = date.trim();
            if (!trimmedDate) {
                return null;
            }
            if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedDate)) {
                return moment(trimmedDate, "YYYY-MM-DD", true);
            }
            return moment(trimmedDate, ["MM/DD/YYYY", "M/D/YYYY"], true);
        }
        return moment(date);
    };
    var handleExportCSV = function () {
        setExportAnchorEl(null);
        if (!payments || payments.length === 0)
            return;
        var headers = exportColumns.map(function (c) { return c.label; }).join(",");
        var rows = payments.map(function (p) {
            return exportColumns
                .map(function (c) { var _a; return "\"".concat(String((_a = p[c.id]) !== null && _a !== void 0 ? _a : "").replace(/"/g, '""'), "\""); })
                .join(",");
        });
        var csv = __spreadArray([headers], rows, true).join("\n");
        var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        var url = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = "payment-management-".concat(getDateRangeLabel(), ".csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    var handleExportExcel = function () {
        setExportAnchorEl(null);
        if (!payments || payments.length === 0)
            return;
        var wsData = __spreadArray([
            exportColumns.map(function (c) { return c.label; })
        ], payments.map(function (p) { return exportColumns.map(function (c) { var _a; return (_a = p[c.id]) !== null && _a !== void 0 ? _a : ""; }); }), true);
        var ws = XLSX.utils.aoa_to_sheet(wsData);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Payments");
        XLSX.writeFile(wb, "payment-management-".concat(getDateRangeLabel(), ".xlsx"));
    };
    var handleExportPDF = function () {
        var _a;
        setExportAnchorEl(null);
        if (!payments || payments.length === 0)
            return;
        var tableHeaders = exportColumns
            .map(function (c) { return "<th>".concat(c.label, "</th>"); })
            .join("");
        var tableRows = payments
            .map(function (p) {
            return "<tr>".concat(exportColumns.map(function (c) { var _a; return "<td>".concat((_a = p[c.id]) !== null && _a !== void 0 ? _a : "", "</td>"); }).join(""), "</tr>");
        })
            .join("");
        var periodLabel = filterType === "dropdown"
            ? period.charAt(0).toUpperCase() + period.slice(1)
            : "".concat(moment(fromDate).format("MM/DD/YYYY"), " \u2013 ").concat(moment(toDate).format("MM/DD/YYYY"));
        var htmlContent = "\n      <html>\n        <head>\n          <title>Payment Management</title>\n          <style>\n            body { font-family: Arial, sans-serif; padding: 20px; }\n            h2 { margin-bottom: 4px; }\n            p { margin: 0 0 16px; color: #666; font-size: 13px; }\n            table { width: 100%; border-collapse: collapse; font-size: 12px; }\n            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }\n            th { background-color: #1a2a5e; color: #fff; font-weight: 600; }\n            tr:nth-child(even) { background-color: #f9f9f9; }\n            @media print { @page { margin: 1cm; } }\n          </style>\n        </head>\n        <body>\n          <h2>Payment Management</h2>\n          <p>Period: ".concat(periodLabel, " &nbsp;|&nbsp; Total Transactions: ").concat(totalCount, "</p>\n          <table>\n            <thead><tr>").concat(tableHeaders, "</tr></thead>\n            <tbody>").concat(tableRows, "</tbody>\n          </table>\n        </body>\n      </html>\n    ");
        var iframe = document.createElement("iframe");
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        var iframeDoc = iframe.contentDocument || ((_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document);
        if (iframeDoc) {
            iframeDoc.write(htmlContent);
            iframeDoc.close();
            setTimeout(function () {
                var _a;
                (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.print();
                setTimeout(function () { return document.body.removeChild(iframe); }, 500);
            }, 300);
        }
    };
    var dateWiseReports = useMemo(function () {
        return schedulerReports
            .map(function (r) {
            var _a;
            return ({
                id: r.id,
                date: moment(r.ReportDate).format("YYYY-MM-DD"),
                name: r.name,
                totalRecords: (_a = r.TotalRecords) !== null && _a !== void 0 ? _a : 0,
                status: r.Status,
            });
        })
            .sort(function (a, b) { return b.date.localeCompare(a.date); });
    }, [schedulerReports]);
    var availableYears = useMemo(function () {
        var years = new Set([moment().year()]);
        schedulerReports.forEach(function (r) {
            var y = moment(r.ReportDate).year();
            if (!isNaN(y))
                years.add(y);
        });
        return Array.from(years).sort(function (a, b) { return b - a; });
    }, [schedulerReports]);
    var availableMonths = useMemo(function () {
        var months = new Set();
        dateWiseReports
            .filter(function (r) { return moment(r.date).year() === selectedReportsYear; })
            .forEach(function (r) { return months.add(moment(r.date).month() + 1); });
        return Array.from(months).sort(function (a, b) { return a - b; });
    }, [dateWiseReports, selectedReportsYear]);
    var monthGroupedReports = useMemo(function () {
        var yearReports = dateWiseReports.filter(function (r) { return moment(r.date).year() === selectedReportsYear; });
        if (selectedReportsMonth !== null) {
            yearReports = yearReports.filter(function (r) { return moment(r.date).month() + 1 === selectedReportsMonth; });
        }
        var groups = {};
        yearReports.forEach(function (r) {
            var key = moment(r.date).format("YYYY-MM");
            if (!groups[key])
                groups[key] = [];
            groups[key].push(r);
        });
        return Object.entries(groups)
            .sort(function (_a, _b) {
            var a = _a[0];
            var b = _b[0];
            return b.localeCompare(a);
        })
            .map(function (_a) {
            var key = _a[0], reports = _a[1];
            return ({
                monthKey: key,
                monthLabel: moment(key, "YYYY-MM").format("MMMM YYYY"),
                reports: reports,
                totalCount: reports.length,
            });
        });
    }, [dateWiseReports, selectedReportsYear, selectedReportsMonth]);
    var fetchSchedulerReports = function (year, month) { return __awaiter(void 0, void 0, void 0, function () {
        var base, fromDate_1, toDate_1, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsReportsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    base = month !== null
                        ? moment().year(year).month(month - 1)
                        : null;
                    fromDate_1 = base
                        ? base.clone().startOf("month").format("YYYY-MM-DD")
                        : moment().year(year).startOf("year").format("YYYY-MM-DD");
                    toDate_1 = base
                        ? base.clone().endOf("month").format("YYYY-MM-DD")
                        : moment().year(year).endOf("year").format("YYYY-MM-DD");
                    return [4, api_service.get({
                            endPoint: api_urls.PAYMENT_SCHEDULER_REPORTS,
                            domain: api_service.BaseDomain.Api,
                            payLoad: { fromDate: fromDate_1, toDate: toDate_1 },
                            showLoader: false,
                        })];
                case 2:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        setSchedulerReports(response.data.data || []);
                    }
                    else {
                        setSchedulerReports([]);
                    }
                    return [3, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error fetching scheduler reports:", error_1);
                    setSchedulerReports([]);
                    return [3, 5];
                case 4:
                    setIsReportsLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var handleSchedulerDownload = function (reportId, date) { return __awaiter(void 0, void 0, void 0, function () {
        var response, blob, url, link, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: "".concat(api_urls.PAYMENT_SCHEDULER_DOWNLOAD, "/").concat(reportId, "/download"),
                            domain: api_service.BaseDomain.Api,
                            responseType: "blob",
                            showLoader: true,
                        })];
                case 1:
                    response = _a.sent();
                    blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    url = URL.createObjectURL(blob);
                    link = document.createElement("a");
                    link.href = url;
                    link.download = "aspire-export-".concat(date, ".xlsx");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                    return [3, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error("Error downloading scheduler report:", error_2);
                    utility.alert("Failed to download report", constants.TOAST_TYPES.ERROR);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var transformPaymentData = function (apiPayments) {
        return apiPayments.map(function (payment) {
            var source = "Other";
            if (payment.Platform === PaymentPlatformTypes.Aspire) {
                source = "ACH";
            }
            else if (payment.Platform === PaymentPlatformTypes.Stripe) {
                source = "Credit Card";
            }
            var aspireStatus = "Pending";
            if (payment.Status === PaymentStatusTypes.Cancelled) {
                aspireStatus = "Cancelled";
            }
            else if (payment.AspireStatus === true) {
                aspireStatus = "Processed";
            }
            else {
                aspireStatus = "Pending";
            }
            var isStripe = payment.Platform === PaymentPlatformTypes.Stripe;
            return {
                id: payment.Id,
                ContractId: payment.AspireContractId || "N/A",
                Customer: payment.Name || "N/A",
                PaymentAmount: isStripe && payment.GrossAmount
                    ? formatCurrency(payment.GrossAmount)
                    : formatCurrency(payment.Amount),
                BaseAmount: isStripe && payment.Amount ? formatCurrency(payment.Amount) : undefined,
                FeeAmount: isStripe && payment.PlatformFee ? formatCurrency(payment.PlatformFee) : undefined,
                Date: moment(payment.PaymentDate).format("YYYY-MM-DD"),
                Source: source,
                PaymentStatus: aspireStatus,
                portalName: getPaymentPortalDisplayName(payment.portalName),
                StripeTransactionId: payment.StripeTransactionId || "--",
                Comments: payment.Comments || "--",
                StripeStatus: StripeStatusLabels[Number(payment.Status)] || "--",
            };
        });
    };
    var FULL_RANGE_FETCH_LIMIT = 10000;
    var fetchPayments = function (page, limit, searchTextFilter) {
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 10; }
        if (searchTextFilter === void 0) { searchTextFilter = ""; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, apiResponse, portalNames, filteredApiPayments, startIndex, pagedPayments, transformedData, pendingTotal_1, processedTotal_1, cancelledTotal_1, error_3, errorMessage;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setIsLoading(true);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        payload = {
                            page: 1,
                            limit: FULL_RANGE_FETCH_LIMIT,
                        };
                        if (searchTextFilter) {
                            payload.searchTerm = searchTextFilter.trim();
                        }
                        if (selectedStatusFilter !== null) {
                            payload.status = selectedStatusFilter;
                        }
                        if (fromDate) {
                            payload.fromDate = moment(fromDate).format("YYYY-MM-DD");
                        }
                        if (toDate) {
                            payload.toDate = moment(toDate).format("YYYY-MM-DD");
                        }
                        return [4, api_service.get({
                                endPoint: api_urls.CUSTOMER_PORTAL_PAYMENT_LIST,
                                payLoad: payload,
                                showLoader: true,
                            })];
                    case 2:
                        response = _d.sent();
                        if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                            apiResponse = response.data;
                            portalNames = Array.from(new Set(apiResponse.data
                                .map(function (payment) {
                                return getPaymentPortalDisplayName(payment.portalName);
                            })
                                .filter(function (portal) { return portal !== ''; }))).sort();
                            setAvailablePortals(portalNames);
                            filteredApiPayments = selectedPlatformFilter !== null
                                ? apiResponse.data.filter(function (payment) { return payment.Platform === selectedPlatformFilter; })
                                : apiResponse.data;
                            if (selectedPortalFilter !== null) {
                                filteredApiPayments = filteredApiPayments.filter(function (payment) {
                                    return getPaymentPortalDisplayName(payment.portalName) ===
                                        selectedPortalFilter;
                                });
                            }
                            startIndex = (page - 1) * limit;
                            pagedPayments = filteredApiPayments.slice(startIndex, startIndex + limit);
                            transformedData = transformPaymentData(pagedPayments);
                            setPayments(transformedData);
                            setTotalCount(filteredApiPayments.length);
                            pendingTotal_1 = 0;
                            processedTotal_1 = 0;
                            cancelledTotal_1 = 0;
                            filteredApiPayments.forEach(function (payment) {
                                var amount = parseFloat(payment.Amount) || 0;
                                if (payment.Status === PaymentStatusTypes.Pending) {
                                    pendingTotal_1 += amount;
                                }
                                else if (payment.Status === PaymentStatusTypes.Processed) {
                                    processedTotal_1 += amount;
                                }
                                else if (payment.Status === PaymentStatusTypes.Cancelled) {
                                    cancelledTotal_1 += amount;
                                }
                            });
                            setPendingAmount(pendingTotal_1);
                            setProcessedAmount(processedTotal_1);
                            setCancelledAmount(cancelledTotal_1);
                        }
                        else {
                            utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch payments", constants.TOAST_TYPES.ERROR);
                        }
                        return [3, 5];
                    case 3:
                        error_3 = _d.sent();
                        console.error("Error fetching payments:", error_3);
                        errorMessage = ((_c = (_b = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                            (error_3 === null || error_3 === void 0 ? void 0 : error_3.message) ||
                            "Failed to fetch payments";
                        utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                        return [3, 5];
                    case 4:
                        setIsLoading(false);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    var handlePeriodChange = function (selectedPeriod) {
        setPeriod(selectedPeriod);
        var today = moment().format("YYYY-MM-DD");
        if (selectedPeriod === "day") {
            setFromDate(today);
            setToDate(today);
        }
        else if (selectedPeriod === "weekly") {
            var fromDateStr = moment().subtract(6, "days").format("YYYY-MM-DD");
            setFromDate(fromDateStr);
            setToDate(today);
        }
        else if (selectedPeriod === "monthly") {
            var fromDateStr = moment().subtract(29, "days").format("YYYY-MM-DD");
            setFromDate(fromDateStr);
            setToDate(today);
        }
        else if (selectedPeriod === "yearly") {
            setFromDate(moment().startOf("day").subtract(364, "days").format("YYYY-MM-DD"));
            setToDate(today);
        }
        setCurrentPage(1);
    };
    var handleStatusFilterClick = function (status) {
        setSelectedStatusFilter(status);
        setCurrentPage(1);
    };
    var getValidSearchText = function (text) {
        if (!text)
            return null;
        if (text.startsWith("$")) {
            if (text.length === 1)
                return null;
            return text.slice(1).replace(/,/g, "");
        }
        return text;
    };
    useEffect(function () {
        var validSearchText = getValidSearchText(searchText);
        if (searchText === "$")
            return;
        var callApi = function () {
            if (validSearchText) {
                fetchPayments(currentPage, recordsPerPage, validSearchText);
            }
            else {
                fetchPayments(currentPage, recordsPerPage);
            }
        };
        if (filterType === "dropdown") {
            if (period && fromDate && toDate) {
                callApi();
            }
        }
        else if (filterType === "datepicker") {
            if (!fromDate || !toDate) {
                utility.alert("Select valid date", constants.TOAST_TYPES.ERROR);
                return;
            }
            callApi();
        }
    }, [
        currentPage,
        recordsPerPage,
        filterType,
        period,
        fromDate,
        toDate,
        searchText,
        selectedStatusFilter,
        selectedPlatformFilter,
        selectedPortalFilter,
    ]);
    useEffect(function () {
        var validSearchText = getValidSearchText(searchText);
        if (searchText === "$")
            return;
        if (filterType === "dropdown" && period && fromDate && toDate) {
            validSearchText ? fetchPayments(currentPage, recordsPerPage, validSearchText) : fetchPayments(currentPage, recordsPerPage);
        }
        else if (filterType === "datepicker" && fromDate && toDate) {
            validSearchText ? fetchPayments(currentPage, recordsPerPage, validSearchText) : fetchPayments(currentPage, recordsPerPage);
        }
    }, [selectedStatusFilter, filterType, period, fromDate, toDate]);
    useEffect(function () {
        if (showReports) {
            fetchSchedulerReports(selectedReportsYear, selectedReportsMonth);
        }
    }, [showReports, selectedReportsYear, selectedReportsMonth]);
    var tableActionHandler = function (rowData, actionType) {
        if (actionType === "Push to Aspire") {
            console.log("Push to Aspire:", rowData);
        }
    };
    var handleSearch = function (searchValue) {
        setSearchText(searchValue);
        setCurrentPage(1);
    };
    return (React.createElement(Stack, { sx: { p: 3, minHeight: "calc(100dvh - 200px)", gap: 1.5 } },
        React.createElement(Box, { sx: { minHeight: 0 } },
            React.createElement(Stack, { direction: "column", spacing: 2 },
                React.createElement(CommonHeader, { mainTitle: "Payment Management", subTitle: "Manage all payments and transactions in one place.", icon: React.createElement(PaymentManagementIcon, { sx: { svg: { height: 24, width: 24 }, height: 24 } }) }),
                React.createElement(Box, { sx: {
                        bgcolor: "#fff",
                        border: "1px solid ".concat(baseColors.greyPreset[40]),
                        borderRadius: 2,
                        p: { xs: 1, sm: 1.5 },
                        "& .MuiInputBase-root": { borderRadius: "8px" },
                        "& .clear-date": { right: "0 !important" }
                    } },
                    React.createElement(Stack, { direction: { xs: "column", sm: "row" }, spacing: 1.5, alignItems: { xs: "stretch", sm: "flex-start" }, sx: { mb: 1.5 } },
                        React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { height: 36 } },
                            React.createElement(Radio, { size: "small", checked: filterType === "dropdown", onChange: function () {
                                    setFilterType("dropdown");
                                    setPeriod("weekly");
                                    var today = moment().format("YYYY-MM-DD");
                                    var weeklyFrom = moment()
                                        .subtract(6, "days")
                                        .format("YYYY-MM-DD");
                                    setFromDate(weeklyFrom);
                                    setToDate(today);
                                    setCurrentPage(1);
                                } }),
                            React.createElement(FormControl, { size: "small", sx: { minWidth: { xs: "auto", sm: 140 }, flex: { xs: 1, sm: 0 } } },
                                React.createElement(Select, { value: period, onChange: function (e) {
                                        handlePeriodChange(e.target.value);
                                    }, disabled: filterType !== "dropdown", sx: {
                                        borderRadius: "8px",
                                        bgcolor: "#fff",
                                        height: 36,
                                        width: "100%",
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                        },
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                            borderWidth: "1px",
                                        },
                                    } },
                                    React.createElement(MenuItem, { value: "day" }, "Daily"),
                                    React.createElement(MenuItem, { value: "weekly" }, "Weekly"),
                                    React.createElement(MenuItem, { value: "monthly" }, "Monthly"),
                                    React.createElement(MenuItem, { value: "yearly" }, "Yearly")))),
                        React.createElement(Divider, { orientation: "vertical", sx: { my: 1, display: { xs: "none", sm: "block" } } }),
                        React.createElement(Stack, { direction: { xs: "column", sm: "row" }, spacing: 1, alignItems: { xs: "stretch", sm: "flex-start" } },
                            React.createElement(Box, { sx: { height: 36, display: "flex", alignItems: "center", flexShrink: 0 } },
                                React.createElement(Radio, { size: "small", checked: filterType === "datepicker", onChange: function () {
                                        setFilterType("datepicker");
                                        var today = moment().format("YYYY-MM-DD");
                                        var sevenDaysAgo = moment()
                                            .subtract(6, "days")
                                            .format("YYYY-MM-DD");
                                        setFromDate(sevenDaysAgo);
                                        setToDate(today);
                                        setCurrentPage(1);
                                    } })),
                            React.createElement(Stack, { direction: { xs: "column", sm: "row" }, spacing: 1, sx: { flex: 1 } },
                                React.createElement(Box, { sx: {
                                        flex: 1,
                                        minWidth: 0,
                                        "& .MuiInputBase-root": { bgcolor: "#fff" },
                                    } },
                                    React.createElement(MUIDatePicker, { labelText: "Start Date", isMandatory: false, selectedDate: filterType === "dropdown" ? "" : fromDate, disabled: filterType !== "datepicker", errorMessage: "", minDate: contractStartDate || undefined, maxDate: maxAllowedDate, dateChangeHandler: function (date) {
                                            if (filterType !== "datepicker")
                                                return;
                                            if (date == null || date === "") {
                                                setFromDate("");
                                                setCurrentPage(1);
                                                return;
                                            }
                                            var dateValidation = validateDate(date);
                                            if (!dateValidation.isValid) {
                                                utility.alert(dateValidation.errorMessage, constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            var parsedDate = parsePaymentFilterDate(date);
                                            if (!parsedDate || !parsedDate.isValid()) {
                                                utility.alert("Invalid date format", constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            if (contractStartDate &&
                                                parsedDate.isBefore(moment(contractStartDate, "YYYY-MM-DD", true))) {
                                                utility.alert("Start date cannot be before contract start date.", constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            if (maxAllowedDate &&
                                                parsedDate.isAfter(moment(maxAllowedDate, "YYYY-MM-DD", true))) {
                                                utility.alert("Start date cannot be after ".concat(moment(maxAllowedDate).format("MM/DD/YYYY"), "."), constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            var formattedDate = parsedDate.format("YYYY-MM-DD");
                                            if (toDate &&
                                                parsedDate.isAfter(moment(toDate, "YYYY-MM-DD", true))) {
                                                utility.alert("Start date cannot be after end date.", constants.TOAST_TYPES.ERROR);
                                                setCurrentPage(1);
                                                return;
                                            }
                                            setFromDate(formattedDate);
                                            setCurrentPage(1);
                                        } })),
                                React.createElement(Box, { sx: {
                                        flex: 1,
                                        minWidth: 0,
                                        "& .MuiInputBase-root": { bgcolor: "#fff" },
                                    } },
                                    React.createElement(MUIDatePicker, { key: "payments-end-".concat(fromDate, "-").concat(toDate, "-").concat(filterType), labelText: "End Date", isMandatory: false, selectedDate: filterType === "dropdown" ? "" : toDate, minDate: contractStartDate || undefined, maxDate: maxAllowedDate, disabled: filterType !== "datepicker", errorMessage: "", dateChangeHandler: function (date) {
                                            if (filterType !== "datepicker")
                                                return;
                                            if (date == null || date === "") {
                                                setToDate("");
                                                setCurrentPage(1);
                                                return;
                                            }
                                            var dateValidation = validateDate(date);
                                            if (!dateValidation.isValid) {
                                                utility.alert(dateValidation.errorMessage, constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            var parsedDate = parsePaymentFilterDate(date);
                                            if (!parsedDate || !parsedDate.isValid()) {
                                                utility.alert("Invalid date format", constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            if (contractStartDate &&
                                                parsedDate.isBefore(moment(contractStartDate, "YYYY-MM-DD", true))) {
                                                utility.alert("End date cannot be before contract start date.", constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            if (maxAllowedDate &&
                                                parsedDate.isAfter(moment(maxAllowedDate, "YYYY-MM-DD", true))) {
                                                utility.alert("End date cannot be after ".concat(moment(maxAllowedDate).format("MM/DD/YYYY"), "."), constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            var formattedDate = parsedDate.format("YYYY-MM-DD");
                                            if (fromDate &&
                                                parsedDate.isBefore(moment(fromDate, "YYYY-MM-DD", true))) {
                                                utility.alert("End date cannot be before start date.", constants.TOAST_TYPES.ERROR);
                                                setCurrentPage(1);
                                                return;
                                            }
                                            setToDate(formattedDate);
                                            setCurrentPage(1);
                                        } }))))),
                    React.createElement(Divider, { sx: { mb: 1.5 } }),
                    React.createElement(Stack, { direction: { xs: "column", sm: "row" }, spacing: 1.5, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between" },
                        React.createElement(Stack, { direction: { xs: "column", sm: "row" }, spacing: 1, alignItems: { xs: "stretch", sm: "center" }, sx: { flex: { xs: 1, sm: 1, md: 0 }, minWidth: 0 } },
                            React.createElement(FormControl, { size: "small", sx: { minWidth: { xs: "100%", sm: 140 } } },
                                React.createElement(Select, { value: selectedPlatformFilter !== null && selectedPlatformFilter !== void 0 ? selectedPlatformFilter : "all", onChange: function (e) {
                                        var val = e.target.value;
                                        setSelectedPlatformFilter(val === "all" ? null : Number(val));
                                        setCurrentPage(1);
                                    }, sx: {
                                        borderRadius: "8px",
                                        bgcolor: "#fff",
                                        height: 36,
                                        fontSize: 13,
                                        width: "100%",
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                        },
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                            borderWidth: "1px",
                                        },
                                    } },
                                    React.createElement(MenuItem, { value: "all" }, "All Payment Modes"),
                                    React.createElement(MenuItem, { value: PaymentPlatformTypes.Aspire }, "ACH"),
                                    React.createElement(MenuItem, { value: PaymentPlatformTypes.Stripe }, "Credit Card"))),
                            React.createElement(FormControl, { size: "small", sx: { minWidth: { xs: "100%", sm: 140 } } },
                                React.createElement(Select, { value: selectedPortalFilter !== null && selectedPortalFilter !== void 0 ? selectedPortalFilter : "all", onChange: function (e) {
                                        var val = e.target.value;
                                        setSelectedPortalFilter(val === "all" ? null : val);
                                        setCurrentPage(1);
                                    }, sx: {
                                        borderRadius: "8px",
                                        bgcolor: "#fff",
                                        height: 36,
                                        fontSize: 13,
                                        width: "100%",
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                        },
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                            borderWidth: "1px",
                                        },
                                    } },
                                    React.createElement(MenuItem, { value: "all" }, "All Portals"),
                                    availablePortals.map(function (portal) { return (React.createElement(MenuItem, { key: portal, value: portal }, portal)); }))),
                            React.createElement(Box, { sx: {
                                    minWidth: { xs: "100%", sm: 0, md: 500 },
                                    flex: { xs: 1, sm: 1, md: 0 },
                                    "& .MuiInputBase-root": { bgcolor: "#fff", height: 36 },
                                } },
                                React.createElement(SearchField, { onSearch: handleSearch, placeholder: "Search By Customer, Contract ID, Amount", value: searchText, debounceTimer: 300 }))),
                        React.createElement(Stack, { direction: { xs: "column", sm: "row" }, spacing: 1, alignItems: { xs: "stretch", sm: "center" }, sx: { flex: { xs: 1, sm: 0 } } },
                            React.createElement(Button, { variant: "outlined", onClick: function () { return setShowReports(function (prev) { return !prev; }); }, startIcon: React.createElement(AssessmentIcon, { sx: { fontSize: 18 } }), sx: {
                                    height: 36,
                                    borderRadius: "8px",
                                    borderColor: showReports ? "#1a2a5e" : "#192A5E",
                                    color: showReports ? "#1a2a5e" : "#192A5E",
                                    fontWeight: showReports ? 700 : 500,
                                    whiteSpace: "nowrap",
                                    textTransform: "none",
                                    px: 2,
                                    width: { xs: "100%", sm: "auto" },
                                    bgcolor: showReports ? "rgba(26,42,94,0.06)" : "#fff",
                                    "&:hover": {
                                        borderColor: "#1a2a5e",
                                        bgcolor: "rgba(26,42,94,0.04)",
                                    },
                                } }, "Aspire Export Reports"),
                            React.createElement(Button, { variant: "outlined", onClick: function (e) { return setExportAnchorEl(e.currentTarget); }, endIcon: React.createElement(KeyboardArrowDownIcon, { sx: { fontSize: 18 } }), sx: {
                                    height: 36,
                                    borderRadius: "8px",
                                    borderColor: "#1a2a5e",
                                    color: "#1a2a5e",
                                    fontWeight: 600,
                                    whiteSpace: "nowrap",
                                    textTransform: "none",
                                    px: 2,
                                    width: { xs: "100%", sm: "auto" },
                                    "& .MuiButton-endIcon": { ml: 0.5 },
                                    "&:hover": {
                                        borderColor: "#1a2a5e",
                                        bgcolor: "rgba(26,42,94,0.04)",
                                    },
                                } }, "Export"))))),
            React.createElement(Dialog, { open: showReports, onClose: function () {
                    setShowReports(false);
                    setReportsPage(1);
                    setSelectedReportsMonth(null);
                }, fullWidth: true, maxWidth: "md", PaperProps: {
                    sx: {
                        borderRadius: 3,
                        height: "80vh",
                        maxHeight: 720,
                        display: "flex",
                        flexDirection: "column",
                    },
                } },
                React.createElement(DialogTitle, { sx: { px: 3, py: 2, flexShrink: 0 } },
                    React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between" },
                        React.createElement(Box, null,
                            React.createElement(Typography, { variant: "h6", fontWeight: 700 }, "Aspire Export Reports"),
                            React.createElement(Typography, { variant: "caption", color: "text.secondary" }, (function () {
                                var total = monthGroupedReports.reduce(function (s, m) { return s + m.reports.length; }, 0);
                                var periodLabel = selectedReportsMonth !== null
                                    ? "".concat(moment().month(selectedReportsMonth - 1).format("MMMM"), " ").concat(selectedReportsYear)
                                    : selectedReportsYear;
                                return "".concat(total, " day report").concat(total !== 1 ? "s" : "", " in ").concat(periodLabel);
                            })())),
                        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1.5 },
                            React.createElement(FormControl, { size: "small" },
                                React.createElement(Select, { value: selectedReportsYear, onChange: function (e) {
                                        setSelectedReportsYear(Number(e.target.value));
                                        setSelectedReportsMonth(null);
                                        setReportsPage(1);
                                    }, sx: {
                                        borderRadius: "8px",
                                        height: 36,
                                        minWidth: 100,
                                        fontSize: 14,
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                        },
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#1a2a5e",
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#1a2a5e",
                                            borderWidth: "1px",
                                        },
                                    } }, availableYears.map(function (y) { return (React.createElement(MenuItem, { key: y, value: y }, y)); }))),
                            React.createElement(FormControl, { size: "small" },
                                React.createElement(Select, { value: selectedReportsMonth !== null && selectedReportsMonth !== void 0 ? selectedReportsMonth : "all", onChange: function (e) {
                                        setSelectedReportsMonth(e.target.value === "all"
                                            ? null
                                            : Number(e.target.value));
                                        setReportsPage(1);
                                    }, displayEmpty: true, sx: {
                                        borderRadius: "8px",
                                        height: 36,
                                        minWidth: 130,
                                        fontSize: 14,
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#a3a9b9",
                                        },
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#1a2a5e",
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#1a2a5e",
                                            borderWidth: "1px",
                                        },
                                    } },
                                    React.createElement(MenuItem, { value: "all" }, "All Months"),
                                    availableMonths.length === 0 ? (React.createElement(MenuItem, { disabled: true, value: "" }, "No data")) : (availableMonths.map(function (m) { return (React.createElement(MenuItem, { key: m, value: m }, moment().month(m - 1).format("MMMM"))); })))),
                            React.createElement(IconButton, { size: "small", onClick: function () {
                                    setShowReports(false);
                                    setReportsPage(1);
                                    setSelectedReportsMonth(null);
                                } },
                                React.createElement(CloseIcon, { fontSize: "small" }))))),
                React.createElement(Divider, null),
                React.createElement(DialogContent, { sx: { p: 0, overflowY: "auto", flex: 1 } }, isReportsLoading ? (React.createElement(Stack, { alignItems: "center", justifyContent: "center", sx: { height: "100%", py: 6 } },
                    React.createElement(CircularProgress, { size: 36 }))) : monthGroupedReports.length === 0 ? (React.createElement(Stack, { alignItems: "center", justifyContent: "center", sx: { height: "100%", py: 6, gap: 1.5 } },
                    React.createElement(Box, { sx: {
                            width: 72,
                            height: 72,
                            borderRadius: "50%",
                            bgcolor: "#f0f3fb",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        } },
                        React.createElement(AssessmentIcon, { sx: { fontSize: 36, color: "#a3a9b9" } })),
                    React.createElement(Typography, { variant: "subtitle1", fontWeight: 700, color: "text.primary" },
                        "No reports for",
                        " ",
                        selectedReportsMonth !== null
                            ? "".concat(moment().month(selectedReportsMonth - 1).format("MMMM"), " ").concat(selectedReportsYear)
                            : selectedReportsYear),
                    React.createElement(Typography, { variant: "body2", color: "text.secondary", textAlign: "center", sx: { maxWidth: 300 } }, selectedReportsMonth !== null
                        ? "No payment records found for the selected month. Try selecting a different month or switch to All Months."
                        : "There are no payment records for this year. Try selecting a different year from the dropdown."))) : (monthGroupedReports
                    .slice((reportsPage - 1) * MONTHS_PER_PAGE, (reportsPage - 1) * MONTHS_PER_PAGE + MONTHS_PER_PAGE)
                    .map(function (monthGroup) { return (React.createElement(Box, { key: monthGroup.monthKey },
                    React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", sx: {
                            px: 3,
                            py: 1,
                            bgcolor: "#f6f8fc",
                            borderBottom: "1px solid #e0e4ef",
                        } },
                        React.createElement(Typography, { variant: "caption", fontWeight: 700, sx: {
                                color: "#1a2a5e",
                                textTransform: "uppercase",
                                letterSpacing: 0.8,
                            } }, monthGroup.monthLabel),
                        React.createElement(Typography, { variant: "caption", color: "text.secondary" },
                            monthGroup.totalCount,
                            " report",
                            monthGroup.totalCount !== 1 ? "s" : "")),
                    monthGroup.reports.map(function (report, idx) { return (React.createElement(React.Fragment, { key: report.date },
                        React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", sx: { px: 3, py: 1.75 } },
                            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1.5 },
                                React.createElement(Box, { sx: {
                                        width: 40,
                                        height: 40,
                                        borderRadius: 1.5,
                                        bgcolor: "#e8edf8",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                    } },
                                    React.createElement(InsertDriveFileIcon, { sx: { fontSize: 20, color: "#1a2a5e" } })),
                                React.createElement(Box, null,
                                    React.createElement(Typography, { variant: "body2", fontWeight: 700 }, moment(report.date).format("MMM DD, YYYY")),
                                    React.createElement(Typography, { variant: "caption", color: "text.secondary" },
                                        report.totalRecords,
                                        " record",
                                        report.totalRecords !== 1 ? "s" : ""))),
                            React.createElement(Stack, { direction: "row", spacing: 1 },
                                React.createElement(Button, { variant: "outlined", size: "small", startIcon: React.createElement(FileDownloadIcon, { sx: { fontSize: 16 } }), onClick: function () {
                                        return handleSchedulerDownload(report.id, report.date);
                                    }, sx: {
                                        borderRadius: "8px",
                                        borderColor: "#c5cae9",
                                        color: "#333",
                                        textTransform: "none",
                                        fontWeight: 600,
                                        fontSize: 13,
                                        px: 1.5,
                                        "&:hover": {
                                            borderColor: "#1a2a5e",
                                            bgcolor: "rgba(26,42,94,0.04)",
                                        },
                                    } }, "Download"))),
                        idx < monthGroup.reports.length - 1 && (React.createElement(Divider, { sx: { mx: 3 } })))); }),
                    React.createElement(Divider, null))); }))),
                monthGroupedReports.length > MONTHS_PER_PAGE && (React.createElement(React.Fragment, null,
                    React.createElement(Divider, null),
                    React.createElement(Box, { sx: { px: 2, py: 1 } },
                        React.createElement(CommonTablePagination, { tableData: monthGroupedReports, currentPage: reportsPage, perPageCount: MONTHS_PER_PAGE, setCurrentPage: setReportsPage, setPerPageCount: function () { }, hideRowsPerPage: true }))))),
            React.createElement(Stack, { sx: {
                    "& .summary-cards": {
                        borderRadius: 2,
                        p: 2,
                        height: "100%",
                        "& .summary-cards-icon": {
                            width: 44,
                            height: 44,
                            borderRadius: 1.5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        },
                    },
                } },
                React.createElement(Grid, { container: true, spacing: 2, sx: { mb: 2, mt: 1 }, alignItems: "flex-start" },
                    React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                        React.createElement(Stack, { className: "summary-cards", onClick: function () { return handleStatusFilterClick(null); }, sx: {
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                bgcolor: selectedStatusFilter === null
                                    ? colors.creamPreset[10]
                                    : "#FFFFFF",
                                border: selectedStatusFilter === null
                                    ? "1px solid ".concat(colors.yellowShades[11])
                                    : "1px solid transparent",
                                "&:hover": {
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    transform: "translateY(-2px)",
                                },
                                "& .summary-cards-icon": {
                                    bgcolor: colors.yellowShades[11],
                                },
                            } },
                            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2, justifyContent: "space-between" },
                                React.createElement(Box, null,
                                    React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 0.5 } }, "Total Transactions"),
                                    React.createElement(Typography, { variant: "h5", sx: { fontWeight: 600 } }, totalCount || 0)),
                                React.createElement(Box, { className: "summary-cards-icon" },
                                    React.createElement(TotalTranscationIcon, null))))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                        React.createElement(Stack, { className: "summary-cards", onClick: function () {
                                return handleStatusFilterClick(PaymentStatusTypes.Pending);
                            }, sx: {
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                bgcolor: selectedStatusFilter === PaymentStatusTypes.Pending
                                    ? colors.creamPreset[10]
                                    : "#FFFFFF",
                                border: selectedStatusFilter === PaymentStatusTypes.Pending
                                    ? "1px solid ".concat(colors.yellowShades[11])
                                    : "1px solid transparent",
                                "&:hover": {
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    transform: "translateY(-2px)",
                                },
                                "& .summary-cards-icon": {
                                    bgcolor: colors.yellowShades[11],
                                },
                            } },
                            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2, justifyContent: "space-between" },
                                React.createElement(Box, null,
                                    React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 0.5 } }, "Pending Amount"),
                                    React.createElement(Typography, { variant: "h5", sx: { fontWeight: 600 } }, formatCurrency(pendingAmount))),
                                React.createElement(Box, { className: "summary-cards-icon" },
                                    React.createElement(TotalAmountIcon, null))))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                        React.createElement(Stack, { className: "summary-cards", onClick: function () {
                                return handleStatusFilterClick(PaymentStatusTypes.Processed);
                            }, sx: {
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                bgcolor: selectedStatusFilter === PaymentStatusTypes.Processed
                                    ? colors.creamPreset[10]
                                    : "#FFFFFF",
                                border: selectedStatusFilter === PaymentStatusTypes.Processed
                                    ? "1px solid ".concat(colors.yellowShades[11])
                                    : "1px solid transparent",
                                "&:hover": {
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    transform: "translateY(-2px)",
                                },
                                "& .summary-cards-icon": {
                                    bgcolor: colors.yellowShades[11],
                                },
                            } },
                            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2, justifyContent: "space-between" },
                                React.createElement(Box, null,
                                    React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 0.5 } }, "Processed Amount"),
                                    React.createElement(Typography, { variant: "h5", sx: { fontWeight: 600 } }, formatCurrency(processedAmount))),
                                React.createElement(Box, { className: "summary-cards-icon" },
                                    React.createElement(TotalAmountIcon, null))))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                        React.createElement(Stack, { className: "summary-cards", onClick: function () {
                                return handleStatusFilterClick(PaymentStatusTypes.Cancelled);
                            }, sx: {
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                bgcolor: selectedStatusFilter === PaymentStatusTypes.Cancelled
                                    ? colors.creamPreset[10]
                                    : "#FFFFFF",
                                border: selectedStatusFilter === PaymentStatusTypes.Cancelled
                                    ? "1px solid ".concat(colors.yellowShades[11])
                                    : "1px solid transparent",
                                "&:hover": {
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    transform: "translateY(-2px)",
                                },
                                "& .summary-cards-icon": {
                                    bgcolor: colors.yellowShades[11],
                                },
                            } },
                            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2, justifyContent: "space-between" },
                                React.createElement(Box, null,
                                    React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 0.5 } }, "Cancelled Amount"),
                                    React.createElement(Typography, { variant: "h5", sx: { fontWeight: 600 } }, formatCurrency(cancelledAmount))),
                                React.createElement(Box, { className: "summary-cards-icon" },
                                    React.createElement(TotalAmountIcon, null))))))),
            React.createElement(Box, { className: "common-module-wrapper" },
                React.createElement(Box, { ref: tableFillRef, className: "module-common-table-wrapper", sx: { marginLeft: "0px !important", marginRight: "0px !important" } },
                    React.createElement(ModuleTable, { dataToDisplay: payments, columns: CustomerPortalPaymentManagementCols, isLoading: isLoading, isRowClickEnabled: false, actionHandler: tableActionHandler, moduleName: "Customer Portal Payment Management", isPortalSelected: true, isActionColumn: false, activePage: currentPage, recordsPerPage: recordsPerPage, setActivePage: setCurrentPage, setRecordsPerPage: setRecordsPerPage, totalNumberOfRecords: totalCount, customerPoratl: true, tableContainerMaxHeight: tableFillMaxHeight, hidePagination: true })))),
        React.createElement(Box, { sx: { flexShrink: 0 } },
            React.createElement(CommonTablePagination, { tableData: payments, setCurrentPage: setCurrentPage, setPerPageCount: setRecordsPerPage, currentPage: currentPage, perPageCount: recordsPerPage, totalNumberOfRecords: totalCount })),
        React.createElement(Box, { mb: "3px" },
            React.createElement(Menu, { anchorEl: exportAnchorEl, open: Boolean(exportAnchorEl), onClose: function () { return setExportAnchorEl(null); }, anchorOrigin: { vertical: "bottom", horizontal: "right" }, transformOrigin: { vertical: "top", horizontal: "right" }, PaperProps: {
                    sx: {
                        mt: 0.5,
                        borderRadius: 2,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                        border: "1px solid #e0e0e0",
                        minWidth: 140,
                        "& .MuiList-root": {
                            py: 0.5,
                            display: "flex",
                            flexDirection: "column",
                            gap: 0,
                        },
                        "& .MuiButtonBase-root": {
                            justifyContent: "space-between",
                        },
                    },
                } },
                React.createElement(MenuItem, { onClick: handleExportCSV, sx: { gap: 2, fontSize: 14 } },
                    React.createElement(Typography, { variant: "body2" }, "CSV")),
                React.createElement(MenuItem, { onClick: handleExportExcel, sx: { gap: 2, fontSize: 14 } },
                    React.createElement(Typography, { variant: "body2" }, "Excel")),
                React.createElement(MenuItem, { onClick: handleExportPDF, sx: { gap: 2, fontSize: 14 } },
                    React.createElement(Typography, { variant: "body2" }, "PDF"))))));
};
export default CustomerPortalPaymentManagement;
